import {
  CookieStorage,
  type KeyValueStorageInterface,
} from 'aws-amplify/utils';

type CookieStorageData = ConstructorParameters<typeof CookieStorage>[0];

export const createClientCookieStorage = (
  data: CookieStorageData,
): KeyValueStorageInterface => {
  return new CookieStorage(data);
};
